module.exports = __webpack_public_path__ + "img/2w-50b_25_36v.prt.67488700.jpg";